export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-primary-100/30 blur-3xl -translate-y-1/2 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-accent-100/25 blur-3xl translate-y-1/3 -translate-x-1/4"></div>

      <div className="section-container relative z-10 w-full">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm font-medium tracking-wide mb-5">
              热门影视品牌聚合
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              青青草视频
              <span className="block text-foreground-700 font-body font-normal text-lg md:text-xl mt-2">
                高清免费影视聚合平台
              </span>
            </h1>

            <p className="text-foreground-500 font-light text-xl md:text-2xl mb-5">
              一站聚合 · 多平台畅享
            </p>

            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              青青草视频精心整合香蕉视频、红桃视频、91视频、蜜桃视频、樱花视频、糖豆视频、樱桃视频等多家热门影视平台资源，
              致力于为用户提供高清流畅、无需缓冲的免费在线观影体验。
              无论您是想探索新平台、寻找特定内容，还是追求更流畅的播放品质，
              这里都是您发现优质影视品牌的最佳入口。每日更新，覆盖多元题材，持续拓展合作平台。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">15+</div>
                <div className="text-xs text-foreground-500 mt-1">合作影视平台</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-600">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">内容持续上新</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">高清流畅</div>
                <div className="text-xs text-foreground-500 mt-1">不缓冲播放体验</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                查看热门排行
              </a>
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-lg border-2 border-foreground-200 text-foreground-700 font-medium text-sm hover:border-primary-400 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-grid-line"></i>
                精选推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20abstract%20artistic%20illustration%20of%20streaming%20entertainment%20and%20video%20content%2C%20warm%20coral%20and%20golden%20amber%20tones%2C%20flowing%20cinematic%20visual%20elements%20representing%20film%20and%20media%2C%20modern%20digital%20aesthetic%20with%20soft%20gradient%20background%2C%20elegant%20composition%20with%20visual%20depth%2C%20no%20text%20no%20people%2C%20abstract%20geometric%20patterns%20evoking%20creativity%20and%20entertainment&width=1000&height=750&seq=hero-main-2026&orientation=landscape"
                alt="青青草视频影视聚合平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}